export default __webpack_public_path__ + "static/media/J1772.4120cb30.svg";